/**
 * PlansPage - Placeholder for Plans & Pricing admin section
 */

import { Card, Typography, Empty } from "antd";
import { MaterialIcon } from "@/components/MaterialIcon";

const { Title, Text } = Typography;

export default function PlansPage() {
  return (
    <div>
      <Title level={3}>Plans & Pricing</Title>
      <Text type="secondary" style={{ display: "block", marginBottom: 24 }}>
        Configure subscription plans and pricing tiers.
      </Text>

      <Card>
        <Empty
          image={<MaterialIcon name="payments" style={{ fontSize: 64, color: "#ccc" }} />}
          description={
            <span>
              Plans & Pricing configuration coming soon.
              <br />
              This section will allow you to manage subscription tiers and features.
            </span>
          }
        />
      </Card>
    </div>
  );
}
